import _ from "lodash";
import { push } from "react-router-redux";

import IMeta from "models/IMeta";
import { localRequest } from "../../apiUtils";
import { setLoading } from "../app/actions";
import URLS from "constants/urlConstants";
import { CUSTOM_SETTINGS } from "constants/.";

export const actionTypes = {
  GET_NOTIFICATIONS_REQUEST: "GET_NOTIFICATIONS_REQUEST",
  GET_NOTIFICATIONS_SUCCESS: "GET_NOTIFICATIONS_SUCCESS",
  GET_NOTIFICATIONS_FAILURE: "GET_NOTIFICATIONS_FAILURE",
  GET_NOTIFICATION_REQUEST: "GET_NOTIFICATION_REQUEST",
  GET_NOTIFICATION_SUCCESS: "GET_NOTIFICATION_SUCCESS",
  GET_NOTIFICATION_FAILURE: "GET_NOTIFICATION_FAILURE",
  SAVE_NOTIFICATION_REQUEST: "SAVE_NOTIFICATION_REQUEST",
  SAVE_NOTIFICATION_SUCCESS: "SAVE_NOTIFICATION_SUCCESS",
  SAVE_NOTIFICATION_FAILURE: "SAVE_NOTIFICATION_FAILURE",
  REMOVE_NOTIFICATION_SUCCESS: "REMOVE_NOTIFICATION_SUCCESS",
  REMOVE_NOTIFICATION_FAILURE: "REMOVE_NOTIFICATION_FAILURE"
};

export default class Actions {
  public static getNotifications(meta = {} as IMeta, isCurrent = false) {
    return async (dispatch, getState) => {
      dispatch(request());
      dispatch(setLoading(true));

      const savedMeta = _.get(getState(), "notifications.meta", {});

      if (_.isEmpty(meta) && !isCurrent) {
        meta = savedMeta;
      }

      if (!meta.pageSize) {
        const savedSettings = JSON.parse(
          localStorage.getItem("customSettings") || "{}"
        );
        _.set(
          meta,
          "pageSize",
          _.get(
            savedSettings,
            `${CUSTOM_SETTINGS.myNotifications}.pageSize`,
            10
          )
        );
      }

      try {
        const { data } = await localRequest.get("messages", {
          params: { ...meta, isCurrent }
        });
        const newMeta = !isCurrent
          ? { ...meta, ...data.meta }
          : { ...savedMeta, ...data.meta };

        dispatch(success(data.rows, newMeta));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_NOTIFICATIONS_REQUEST };
    }
    function success(payload, meta) {
      return {
        type: actionTypes.GET_NOTIFICATIONS_SUCCESS,
        payload,
        meta
      };
    }
    function failure(error) {
      return { type: actionTypes.GET_NOTIFICATIONS_FAILURE, error };
    }
  }

  public static getNotification(id) {
    return async dispatch => {
      dispatch(request());
      dispatch(setLoading(true));
      try {
        const { data } = await localRequest.get(`messages/${id}`);
        dispatch(success(data));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_NOTIFICATION_REQUEST };
    }
    function success(payload) {
      return { type: actionTypes.GET_NOTIFICATION_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.GET_NOTIFICATION_FAILURE, error };
    }
  }

  public static saveNotification(params) {
    return async dispatch => {
      dispatch(request());
      dispatch(setLoading(true));

      try {
        const { data } = await localRequest.post("messages", params);
        dispatch(success(data));
        dispatch(setLoading(false));
        dispatch(push(URLS.MY_NOTIFICATIONS_URL));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.SAVE_NOTIFICATION_REQUEST };
    }
    function success(payload) {
      return {
        type: actionTypes.SAVE_NOTIFICATION_SUCCESS,
        payload
      };
    }
    function failure(error) {
      return { type: actionTypes.SAVE_NOTIFICATION_FAILURE, error };
    }
  }

  public static removeNotifications(ids) {
    return async (dispatch, getState) => {
      dispatch(setLoading(true));

      try {
        await Promise.all(
          ids.map(async id => {
            await localRequest.delete(`messages/${id}`);
          })
        );
        dispatch(success(getState().notifications.items));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function success(items) {
      const payload = items.filter(i => !_.includes(ids, i._id));
      return { type: actionTypes.REMOVE_NOTIFICATION_SUCCESS, payload };
    }
    function failure(error) {
      return { type: actionTypes.REMOVE_NOTIFICATION_FAILURE, error };
    }
  }
}
